export default function Test() {
    return (
      <>
      <h1>Welcome to Test page</h1>
      <p>If you are stumbling upon this page, then you may want to look at the content offered by us.</p>
      <a href="https://www.spielezone.xyz">Visit</a>
      </>
    );
  }